const privacyContent = `<html>

<head>
<meta http-equiv=Content-Type content="text/html; charset=utf-8">
<meta name=Generator content="Microsoft Word 15 (filtered)">
<style>
.privacyContent {
  font-size: 10.5pt !important;
}
</style>

</head>

<body lang=ZH-CN link=blue vlink="#954F72" style='word-wrap:break-word;
text-justify-trim:punctuation'>

<div class=privacyContent >


<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><span >更新日期：2023年 12月21日</span></p>

<p class=MsoNormal><span >生效日期：2023年 12月21日</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >《<span
style='color:black'>蛮啾</span>隐私政策》（以下简称“<b>本隐私政策</b>”）由您（以下亦称“<b>玩家</b>”或“<b>用户</b>”）与上海<span
style='color:black'>蛮啾</span>网络科技有限公司（注册地址上海市杨浦区翔殷路</span><span lang=EN-US
style='font-family:"Times New Roman",serif'>1128</span><span >号</span><span lang=EN-US style='font-family:"Times New Roman",serif'>2</span><span
>层</span><span lang=EN-US style='font-family:"Times New Roman",serif'>230</span><span
>室，上海<span style='color:black'>蛮啾</span>网络科技有限公司</span><span
>及其关联公司</span><span >以下统称“<b><span
style='color:black'>蛮啾</span></b>”，亦称“<b>我们</b>”）共同缔结，具有合同效力。本隐私政策为</span><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/zh/protocol/userAgreement"  target="_blank"><span lang=EN-US
><span lang=EN-US>《</span></span><span lang=EN-US
style=';color:black'><span lang=EN-US>蛮啾</span></span><span
lang=EN-US ><span lang=EN-US>用户许可及服务协议》</span></span></a></span><span
>不可分割的一部分，除另有约定外，本隐私政策所用术语与</span><span lang=EN-US
style='font-family:"Times New Roman",serif'><a
href="/zh/protocol/userAgreement" target="_blank"><span lang=EN-US
><span lang=EN-US>《</span></span><span lang=EN-US
style=';color:black'><span lang=EN-US>蛮啾</span></span><span
lang=EN-US ><span lang=EN-US>用户许可及服务协议》</span></span></a></span><span
>相同。本隐私政策适用于您与<span style='color:black'>蛮啾</span>的交互行为及</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span><span
>或您注册和使用<span style='color:black'>蛮啾</span>提供的所有产品或服务（以下统称</span><span
>“<b><span style='color:black'>蛮啾</span>服务</b>”或“<b>服务</b>”）</span><span
>。</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span lang=EN-US
style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><b><span style='font-size:12.0pt;'>隐私政策概要</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-size:12.0pt;font-family:
"Times New Roman",serif'>&nbsp;</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span style=';
color:black'>蛮啾</span><span >深知个人信息安全对您的重要性，将尽全力保护您的个人信息安全。我们将按照合法、正当、必要和诚信的原则收集、使用、处理您的个人信息。本隐私政策主要向您说明，在您使用<span
style='color:black'>蛮啾</span>产品及服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供访问、更新、控制和保护这些信息的方式。</span></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span >当您点击“同意”、“接受”或“下一步”等具有认可含义的词语时，或您注册、使用或继续使用<span
style='color:black'>蛮啾</span>提供的服务，均视为您已阅读并同意接受本隐私政策以及我们在各项产品或服务中设置的相关隐私说明在此情况下您同时受本隐私政策和相关说明的约束。</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >在使用各项<span
style='color:black'>蛮啾</span>产品及服务前，请您务必审慎阅读、充分理解各条款内容，<b>特别是以加粗、下划线或其他合理方式提示您特别注意的条款，您应重点阅读，在确认充分理解并同意后再开始使用。如果您不同意本隐私政策的内容，将可能导致全部或部分<span
style='color:black'>蛮啾</span>产品及服务无法正常提供，或者无法达到预期服务效果。</b></span></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span >【未成年人用户特别说明】</span></b></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span >若您为未成年人用户，在使用<span
style='color:black'>蛮啾</span>提供的产品和服务前，请在父母或者其他监护人的陪同下阅读本协议，特别注意未成年人相关条款，并在获得法定监护人同意后才可使用<span
style='color:black'>蛮啾</span>产品及服务。我们鼓励未成年人的父母或其他监护人指导未成年人使用本产品和服务。若您登录、注册、使用或接受<span
style='color:black'>蛮啾</span>提供的产品或服务，即表示：您已年满</span></b><b><span lang=EN-US
style='font-family:"Times New Roman",serif'>18</span></b><b><span
>周岁；或：您未满</span></b><b><span lang=EN-US style='font-family:
"Times New Roman",serif'>18</span></b><b><span >周岁，但已获得法定监护人的同意。</span></b></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span >【儿童特别说明】</span></b></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span >如果您是不满</span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>14</span></b><b><span
>周岁的儿童，我们特别提请您注意，请通知您的监护人共同阅读本隐私政策，特别是</span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/zh/protocol/childProtection" target="_blank"><span lang=EN-US
><span lang=EN-US>《</span></span><span lang=EN-US
style=';color:black'><span lang=EN-US>蛮啾</span></span><span
lang=EN-US ><span lang=EN-US>儿童隐私保护规则<span lang=EN-US>及监护人须知</span></span></span><span
lang=EN-US ><span lang=EN-US>》</span></span></a></span></b><b><span
>，并在您提交个人信息、使用<span style='color:black'>蛮啾</span>产品及服务之前，寻求并取得您的监护人的同意和指导。您点击同意本隐私政策，或者您使用</span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span></b><b><span
>继续使用<span style='color:black'>蛮啾</span>产品及服务、提交个人信息，都表示您已获得您的监护人的许可，且您的监护人亦同意受本隐私政策，特别是</span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'><a
href="/zh/protocol/childProtection" target="_blank"><span lang=EN-US
><span lang=EN-US>《</span></span><span lang=EN-US
style=';color:black'><span lang=EN-US>蛮啾</span></span><span
lang=EN-US ><span lang=EN-US>儿童隐私保护规则<span lang=EN-US>及监护人须知</span></span></span><span
lang=EN-US ><span lang=EN-US>》</span></span></a></span></b><b><span
>的约束。</span></b></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span >【监护人特别说明】</span></b></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span >若您是未成年人或非为完全民事行为能力人的监护人，我们特别提请您注意，请您要求您的被监护人在您的监护下共同阅读并接受本隐私政策，且应在您的同意和指导下提交个人信息、使用<span
style='color:black'>蛮啾</span>产品及服务。如果您不同意本隐私政策的内容，您应要求您的被监护人立即停止使用<span
style='color:black'>蛮啾</span>产品及服务。若您点击同意本隐私政策，或者您的被监护人使用或继续使用我们的服务，即表示您和您的被监护人同意受本隐私政策的约束。</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >如果您对本隐私政策或与本隐私政策相关的事宜有任何意见或建议，可通过<span
style='color:black'>蛮啾</span>官方公布的联系方式与我们取得联系，我们会给予您必要的帮助。</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >本隐私政策将向您说明以下内容：</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><a href="#one"><span >一、</span><span
style='font-family:"Times New Roman",serif'> </span><span >我们如何收集和使用个人信息</span></a></p>

<p class=MsoNormal style='text-indent:21.0pt'><a href="#two"><span >二、</span><span
style='font-family:"Times New Roman",serif'> </span><span >我们如何使用</span><span lang=EN-US style='font-family:"Times New Roman",serif'>Cookies</span><span
>和同类技术</span></a></p>

<p class=MsoNormal style='text-indent:21.0pt'><a href="#three"><span >三、</span><span
style='font-family:"Times New Roman",serif'> </span><span >我们如何分享、转让、公开披露个人信息</span></a></p>

<p class=MsoNormal style='text-indent:21.0pt'><a href="#four"><span >四、</span><span
style='font-family:"Times New Roman",serif'> </span><span >我们如何存储和保护个人信息</span></a></p>

<p class=MsoNormal style='text-indent:21.0pt'><a href="#five"><span >五、</span><span
style='font-family:"Times New Roman",serif'> </span><span >您如何管理您的个人信息</span><span style='font-family:"Times New Roman",serif'> </span></a></p>

<p class=MsoNormal style='text-indent:21.0pt'><a href="#six"><span >六、</span><span
style='font-family:"Times New Roman",serif'> </span><span>未成年人保护</span></a></p>

<p class=MsoNormal style='text-indent:21.0pt'><a href="#seven"><span >七、</span><span
style='font-family:"Times New Roman",serif'> </span><span >隐私政策的变更</span></a></p>

<p class=MsoNormal style='text-indent:21.0pt'><a href="#eight"><span >八、</span><span
style='font-family:"Times New Roman",serif'> </span><span >其他条款</span></a></p>

<p class=MsoNormal style='text-indent:21.0pt'><a href="#nine"><span >九、</span><span
style='font-family:"Times New Roman",serif'> </span><span >联系我们</span></a></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif;
color:black;background:#EEEEEE'>&nbsp;</span></b></p>

<p id="one" class=MsoNormal><b><span style='font-size:12.0pt;;color:black;
background:#EEEEEE'>一、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;;color:black;background:#EEEEEE'>我们如何收集和使用个人信息</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >在我们向您提供服务的过程中，<span
style='color:black'>蛮啾</span>会出于以下目的，依据法律法规以及遵循合法、正当、必要和诚信的原则，收集和使用您以下类型的个人信息：</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>1.
</span><span >为帮助您完成注册、登录<span style='color:black'>蛮啾</span>提供的产品及服务，您需要向我们提供<b><u>经过实名认证的手机号码</u></b>、设定<u>账号昵称</u>和<u>用户头像</u>，如果您选择不提供，我们将无法为您创建账户并正常向您提供服务，您可能无法使用<span
style='color:black'>蛮啾</span>提供的产品或服务。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.
</span><span >我们部分产品及服务支持您使用第三方平台的账号进行登录，如您使用第三方平台的账号登录的，我们将根据您的授权获取该第三方账号下的相关信息（包括：<u>第三方账号、用户名、昵称、头像及您授权的其他信息</u>，具体以该第三方账号授权页面显示为准）。如您拒绝授权此类信息，则您将无法使用第三方平台的账号登录我们平台，但不影响我们提供的其他产品和服务的正常使用。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>3.
</span><span >依照相关法律法规政策及主管部门要求，您需要进行实名认证以继续使用<span
style='color:black'>蛮啾</span>产品及服务，我们会在获得您同意或您主动提供的情况下收集您的实名身份信息，包括您的<b><u>真实姓名和身份证号</u></b>。您应提供有关您本人真实、合法、准确、有效的身份信息及其他相关信息，且不得以他人身份资料进行实名注册。如您使用第三方账号关联登录<span
style='color:black'>蛮啾</span>产品及服务，<b>经您授权后，我们可能从该第三方处获取您的个人身份信息</b>，收集上述信息是用于完成实名认证。您提供的实名身份信息将与权威数据平台数据源进行比对，如二者比对信息一致，即成功通过认证。<b>上述信息属于<u>敏感个人信息</u>，拒绝提供前述信息可能会导致您无法正常使用我们的产品或服务或使用我们的产品或服务过程中受到相应限制。</b></span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>4.
</span><span >为向您提供<span style='color:black'>蛮啾</span>游戏的基本功能服务，验证账号信息、保障您的游戏账号安全及广告数据监测及验证，同时也为了营造公平、健康及安全的游戏环境，打击破坏游戏公平环境或干扰、破坏游戏服务正常进行的行为（如用于检测盗版、扫描外挂、防止作弊），营造公平、健康及安全的游戏环境，我们需要获取<u>读取</u></span><u><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span></u><u><span
>写入设备外部存储的权限</span></u><span >（如您使用安卓设备，可能涉及的权限有</span><span
>“读取外部存储权限”、“读取<span lang=EN-US>/</span></span><span
>写入</span><span lang=EN-US style='font-family:"Times New Roman",serif'>SD</span><span
>卡内容</span><span >权限”以及“修改<span
lang=EN-US>/</span>删</span><span >除</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>SD</span><span
>卡内容权限</span><span >”，</span><span
>下同），并且会收集您的<u>设备信息（唯一设备识别码、设备序列号、设备制造商、设备名称、设备类型和版本、设备型号、设备样式、设备</u></span><u><span
lang=EN-US style='font-family:"Times New Roman",serif'>MAC</span></u><u><span
>地址）</span></u><span >、<u>网络身份标识信息（</u></span><u><span
lang=EN-US style='font-family:"Times New Roman",serif'>IP</span></u><u><span
>地址）</span></u><span >、<u>操作系统及进程信息</u>、<u>网络环境信息</u>、<u>游戏崩溃记录</u>、<u>游戏日志信息（登录日志、物品日志、游戏对局信息、交友记录及其他游戏日志）</u>。我们可能会使用您的</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>IP</span><span
>地址识别设备连接至互联网时所在的位置，以用于实现特定活动内容及依照相关规定展示您的</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>IP</span><span
>属地。<b>在某些低版本的</b></span><b><span lang=EN-US
style='font-family:"Times New Roman",serif'>Android </span></b><b><span
>系统中，手机厂商可能会对权限申请进行打包处理，在该种情况下，我们获取设备信息的弹窗，可能会显示为是否允许拨打电话和管理通话。如您拒绝提供前述权限或信息将可能导致您无法使用我们的相关产品与服务。</span></b><span
>如您拒绝提供前述权限将可能导致您无法使用我们相关产品的基本功能服务。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>5.
</span><span >为向您提供交易服务，我们会收集<b><u>充值记录、消费记录及其他与交易相关的必要信息</u></b>，以便您查询您的交易记录，同时尽最大程度保护您的虚拟物品安全。前述信息属于<b><u>敏感个人信息</u></b>，收集上述信息为实现产品的消费功能所必须，否则将无法完成交易，但不影响您正常使用基本功能服务（本隐私政策另有说明的除外）。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>6.
</span><span >为净化游戏环境，维护健康的上网环境，我们会收集<u>您在游戏中发送的文字、图片、语音、视频的信息内容</u>，用于过滤色情、暴力、政治、辱骂、恶意广告及其他不当内容。如您拒绝提供前述权限将可能导致您无法使用我们的相关产品功能与服务，但不影响您对基本功能服务的正常使用（本隐私政策另有说明的除外）。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>7.
</span><span >如您希望与其他玩家进行互动交流（如适用），我们可能会向您获取<u>照片或存储文件、麦克风、摄像头的权限</u>，用于为您提供截图保存、图片上传、语音聊天功能。如您拒绝提供前述权限将可能导致您无法使用我们的相关产品功能与服务，但不影响您正常使用游戏的其他功能（本隐私政策另有说明的除外），同时您也可以随时在系统设置中关闭前述权限。除非您主动上传图片、录音、视频信息，我们原则上不会收集该类信息。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>8.
</span><span >为向您提供<span style='color:black'>蛮啾</span>基本功能服务以外的其他附加服务，包括赠品、奖品、生日祝福、问卷调查，我们可能会收集或要求您主动提供您的相关个人信息，包括但不限于<u>出生日期、邮寄地址、电子邮箱、昵称和头像信息</u>。我们可能使用通过短信形式向您的<u>手机号码</u>发送生日祝福、节日祝福或不定期发送营销信息。如您不想接到此类短信，可通过短信内注明的退订方式进行退订或通过本隐私政策第九条提供的方式联系我们，我们将不再对您发送相应短信内容。您不同意提供上述信息，将导致附加服务无法实现或无法达到我们预期达到的效果，但不影响您对基本功能服务的正常使用（本隐私政策另有说明的除外）。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>9.
</span><span >为向您提供安全保障，我们可能会<b><u>收集、使用或整合您的账号信息、交易信息、设备信息、日志信息以及我们关联公司取得您授权或依据法律共享的信息</u></b>，来综合判断您账号及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>10.
</span><span >由于我们的游戏产品和服务较多，为您提供的内容也不同，因此核心业务功能（包括其收集的您的个人信息类型）也会因游戏产品</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span><span
>服务的内容不同而有所区别，具体以<span style='color:black'>蛮啾</span>产品或服务实际提供为准。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>11.
</span><span >您理解并同意，我们向您提供的功能和服务是不断更新和发展的，<b>如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。一旦同意或继续使用我们的服务，该等额外信息将适用本隐私政策</b>。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>12.
</span><span >您理解并同意，部分单项服务可能需要您在您的设备中开启特定的访问权限，以实现这些权限所涉及信息的收集和使用。需要特别说明的是，获得权限是我们收集特定信息的必要而非充分条件。我们获得具体某一项权限并不代表我们必然会收集您的相关信息；即使我们已经获得权限，也仅在必要时、根据本指引来收集您的相关信息。当您需要关闭某些功能权限时，您可以在设备上随时关闭。请您注意，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权已进行的信息收集及使用。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>13.
</span><b><span >根据相关法律法规及国家标准，若符合下列情形，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>13.1
</span></b><b><span >为订立和履行本隐私政策所必需；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>13.2
</span></b><b><span >为履行法定职责或法定义务所必需；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>13.3
</span></b><b><span >为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>13.4
</span></b><b><span >为公共利益实施新闻报道、舆论监督等行为，在合理的范围内收集和使用个人信息；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>13.5
</span></b><b><span >依照法律法规规定在合理范围内收集和使用您自行公开或其他已经合法公开的个人信息；</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>13.6
</span></b><b><span >法律法规规定的其他情形。</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p  id="two" class=MsoNormal><b><span style='font-size:12.0pt;;color:black;
background:#EEEEEE'>二、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;;color:black;background:#EEEEEE'>我们如何使用</span></b><b><span
lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif;
color:black;background:#EEEEEE'>Cookies</span></b><b><span style='font-size:
12.0pt;;color:black;background:#EEEEEE'>和同类技术</span></b></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1. </span><span
style='font-size:10.5pt;color:black'>为更好地为您服务，在征得您的同意的情况下，</span><span
style='font-size:10.5pt;color:black'>蛮啾</span><span style='font-size:10.5pt;
color:black'>或我们的第三方合作伙伴可能会使用</span><span lang=EN-US style='font-size:10.5pt;
font-family:"Times New Roman",serif;color:black'>Cookies</span><span
style='font-size:10.5pt;color:black'>和同类技术，如脚本、</span><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>Web</span><span
style='font-size:10.5pt;color:black'>信标、</span><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>Flash
Cookies</span><span style='font-size:10.5pt;color:black'>、内嵌</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>Web</span><span style='font-size:10.5pt;color:black'>链接、本地存储器，收集并存储并在某些时刻追踪用户的相关资料。我们将</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>Cookies</span><span style='font-size:10.5pt;color:black'>和同类技术用于：商业、市场分析或学术用途，包括识别用户信息、分析您使用我们服务的情况、广告优化。我们为上述目的使用</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'> Cookies</span><span style='font-size:10.5pt;color:black'>和同类技术的同时，可能将通过</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'> Cookies </span><span style='font-size:10.5pt;color:black'>和同类技术收集的非个人身份信息汇总提供给第三方广告商和其他伙伴，用于分析您和其他用户如何使用我们的服务并用于广告服务。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>2. </span><span
style='font-size:10.5pt;color:black'>我们的产品和服务上可能会有合作伙伴和其他合作方放置的</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'> Cookies</span><span style='font-size:10.5pt;color:black'>和同类技术。这些</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>Cookies</span><span style='font-size:10.5pt;color:black'>和同类技术可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这类第三方</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'> Cookies</span><span style='font-size:10.5pt;color:black'>和同类技术收集和使用该信息不受本隐私政策约束，而是受到该第三方的个人信息保护声明约束，<b>我们不对第三方的</b></span><b><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'> Cookies</span></b><b><span style='font-size:10.5pt;color:black'>和同类技术或第三方对您任何信息的收集或使用承担任何责任。</span></b></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>3. </span><span
style='font-size:10.5pt;color:black'>您可以通过用户选择机制如浏览器的设置拒绝或管理</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'> Cookies </span><span style='font-size:10.5pt;color:black'>或同类技术。但请您注意，如果您停用</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'> Cookies </span><span style='font-size:10.5pt;color:black'>或同类技术，我们有可能无法为您提供最佳的服务体验，某些服务也可能无法正常使用。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p  id="three"  class=MsoNormal><b><span style='font-size:12.0pt;;color:black;
background:#EEEEEE'>三、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;;color:black;background:#EEEEEE'>我们如何分享、转让、公开披露个人信息</span></b></p>

<p class=police-line style='margin:0cm;text-indent:21.0pt;background:white'><span
style='font-size:10.5pt;color:black'>我们将采取适当的技术手段，保证您可以访问、更新和更正您的注册信息或使用我们的产品或服务时提供的其他个人信息。在访问、更新、更正和删除您的个人信息时，我们可能会要求您进行身份验证，以保障您的账户安全。</span></p>

<p class=police-line style='margin:0cm;text-indent:21.0pt;background:white'><span
style='font-size:10.5pt;color:black'>除本隐私政策规定的情形外，我们不会主动分享、转让、披露您的个人信息，如存在其他分享、转让、披露您个人信息至第三方的情形时，我们会直接或间接通过该第三方征得您对上述行为的明示同意。</span></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1. </span></b><b><span
style='font-size:10.5pt;color:black'>我们如何分享信息</span></b></p>

<p class=police-line style='margin:0cm;background:white'><span
style='font-size:10.5pt;color:black'>我们遵照法律法规的规定，对信息的分享进行严格限制。除本隐私政策明确约定、法定无需事先征得您同意或者我们获得您同意的情形外，我们不会与</span><span
style='font-size:10.5pt;color:black'>蛮啾</span><span style='font-size:10.5pt;
color:black'>之外的任何第三方分享您的信息。以下情形特别提请您注意：</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.1  </span><span
style='font-size:10.5pt;color:black'>法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.2  </span><span
style='font-size:10.5pt;color:black'>获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.3 </span><span
style='font-size:10.5pt;color:black'>我们可能会向关联公司、合作伙伴（例如代表我们发出短信或推送通知的通讯服务提供商）分享您的个人信息，用作下列用途：</span></p>

<p class=police-line style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:42.0pt;text-indent:-21.0pt;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.3.1 </span><span
style='font-size:10.5pt;color:black'>实现本隐私政策第一条和第二条所述目的；</span></p>

<p class=police-line style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:42.0pt;text-indent:-21.0pt;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.3.2 </span><span
style='font-size:10.5pt;color:black'>向您提供我们的产品或服务；</span></p>

<p class=police-line style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:42.0pt;text-indent:-21.0pt;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.3.3 </span><span
style='font-size:10.5pt;color:black'>维护和改善我们的产品或服务。</span></p>

<p class=police-line style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
margin-left:42.0pt;text-indent:-21.0pt;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.3.4 </span><span
style='font-size:10.5pt;color:black'>履行我们在本隐私政策或与您达成的其他协议中的义务和行使我们的权利。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.4 </span><span
style='font-size:10.5pt;color:black'>我们还可能为以下需要分享您的个人信息：</span></p>

<p class=police-line style='margin:0cm;text-indent:21.0pt;background:white'><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>1.4.1 </span><span style='font-size:10.5pt;color:black'>基于用户本人或用户监护人的合法要求；</span></p>

<p class=police-line style='margin:0cm;text-indent:21.0pt;background:white'><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>1.4.2 </span><span style='font-size:10.5pt;color:black'>为保护</span><span
style='font-size:10.5pt;color:black'>蛮啾</span><span style='font-size:10.5pt;
color:black'>或您的合法权益且符合法律法规的适当的披露；</span></p>

<p class=police-line style='margin:0cm;text-indent:21.0pt;background:white'><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>1.4.3</span><span style='font-size:10.5pt;color:black'>为保护我们的客户、我们、其他用户或第三方的人身和财产安全或合法权益所合理必需的分享；</span></p>

<p class=police-line style='margin:0cm;text-indent:21.0pt;background:white'><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>1.4.4 </span><span style='font-size:10.5pt;color:black'>根据与您签署的单项服务协议或其他的法律文件约定提供您的信息或者</span><span
style='font-size:10.5pt;color:black'>蛮啾</span><span style='font-size:10.5pt;
color:black'>认为必要的其他情形下。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.5 </span><span
style='font-size:10.5pt;color:black'>如我们与第三方分享您的个人信息，我们仅会出于合法、正当、必要、特定、明确的目的分享您的信息，并且只会共享提供服务所必要的个人信息。同时，我们会要求合作伙伴按照法律法规、本隐私政策及我们要求其遵守的其他适当的保密和安全要求来处理您的个人信息。我们的合作伙伴无权将共享的个人信息用于其他任何用途。如果您拒绝我们的合作伙伴在提供服务时收集为提供服务所必须的个人信息，将可能导致您无法在我们的平台中使用该第三方服务。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>1.6 </span><b><span
style='font-size:10.5pt;color:black'>如您同意由第三方直接收集和处理您的信息，其收集和处理信息等行为应遵守其自身的隐私政策或相关声明，而不适用本隐私政策。为了最大程度保障您的信息安全，我们建议您在使用任何第三方服务前先行查看其隐私政策。为保障您的合法权益，如您发现相关第三方服务存在风险时，建议您立即终止相关操作并及时与我们取得联系，我们会在必要情况下采取相关措施。对任何第三方使用由您提供的信息导致您的合法权益受损，我们不承担任何责任。</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>2. </span></b><b><span
style='font-size:10.5pt;color:black'>我们如何转让信息</span></b></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>2.1 </span><span
style='font-size:10.5pt;color:black'>在获得您的明确同意后，我们会向第三方转让您的个人信息。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>2.2 </span><span
style='font-size:10.5pt;color:black'>随着我们业务的持续发展，我们有可能进行合并、分立、收购、资产转让或类似的交易，而您的信息有可能作为此类交易的一部分而被转移。我们会要求新的持有您信息的公司、组织继续受本隐私政策的约束，否则，我们将要求该公司、组织重新向您征求授权同意。</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>2.3 </span><span
style='font-size:10.5pt;color:black'>在涉及破产清算时，如涉及个人信息转让，我们会要求新的持有您信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>3. </span></b><b><span
style='font-size:10.5pt;color:black'>我们如何披露信息</span></b></p>

<p class=police-line style='margin:0cm;background:white'><span
style='font-size:10.5pt;color:black'>我们仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，披露您的信息：</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>3.1 </span><span
style='font-size:10.5pt;color:black'>获得您的明确同意或基于您的主动选择；</span></p>

<p class=police-line style='margin:0cm;background:white'><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>3.2 </span><span
style='font-size:10.5pt;color:black'>我们可能因需要对违规账号、欺诈行为等进行处罚公告，公布中奖</span><span
lang=EN-US style='font-size:10.5pt;font-family:"Times New Roman",serif;
color:black'>/</span><span style='font-size:10.5pt;color:black'>获胜者等名单时脱敏展示相关信息等必要事宜对您的个人信息进行公开披露，如具备合理事由确需公开披露的，我们会在公开披露前向您告知公开披露的信息的目的、类型（如涉及您的个人敏感信息的，我们还会向您告知涉及的敏感信息的内容），但法律法规另有规定的或本隐私政策另有约定的除外。</span></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4. </span></b><b><span
style='font-size:10.5pt;color:black'>无需取得您事先同意的情况</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span
style='font-size:10.5pt;color:black'>根据相关法律法规及国家标准，以下情形中，我们可能会分享、转让、公开披露个人信息无需事先征得您的授权同意：</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.1 </span></b><b><span
style='font-size:10.5pt;color:black'>为订立和履行本隐私政策所必需；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.2 </span></b><b><span
style='font-size:10.5pt;color:black'>为履行法定职责或法定义务所必需；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.3 </span></b><b><span
style='font-size:10.5pt;color:black'>为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.4 </span></b><b><span
style='font-size:10.5pt;color:black'>为公共利益实施新闻报道、舆论监督等行为，在合理的范围内分享、转让和披露个人信息；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.5 </span></b><b><span
style='font-size:10.5pt;color:black'>依照法律法规规定在合理范围内分享、转让和披露您自行公开或其他已经合法公开的个人信息；</span></b></p>

<p class=police-line style='margin:0cm;background:white'><b><span lang=EN-US
style='font-size:10.5pt;font-family:"Times New Roman",serif;color:black'>4.6 </span></b><b><span
style='font-size:10.5pt;color:black'>法律法规规定的其他情形。</span></b></p>

<p class=police-line style='margin:0cm;text-indent:21.4pt;background:white'><b><span
style='font-size:10.5pt;color:black'>根据法律规定，分享、转让、披露经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别信息主体的，不属于个人信息的对外分享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p id="four"  class=MsoNormal><b><span style='font-size:12.0pt;;color:black;
background:#EEEEEE'>四、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;;color:black;background:#EEEEEE'>我们如何存储和保护个人信息</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>1.
</span></b><b><span >信息的存储</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>1.1
</span><span >存储时限。除法律法规或监管部门另有规定外，我们仅在本隐私政策所述目的所必需且最短的时限内存储您的个人信息。超出存储期限后，我们会对您的个人信息进行删除或匿名化（去标识化）处理。如我们终止服务或运营，我们将及时停止继续收集您个人信息的活动，同时会遵守相关法律法规要求以逐一送达或公告的形式通知用户，并在终止服务或运营后对您的个人信息进行删除或匿名化处理，但法律法规或监管部门另有规定的除外。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>1.2
</span><span >存储地点。我们在中华人民共和国境内运营中产生和收集的个人信息，存储在中国境内。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>1.3
</span><span >存储方式。我们会通过安全的方式存储您的信息，包括本地存储（例如利用</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>APP</span><span
>进行数据缓存）、数据库和服务器日志。</span></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>2.
</span></b><b><span >信息的保护</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >我们努力为用户的信息安全提供保障，以防止信息的泄露、丢失、不当使用、未经授权访问和披露等。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.1
</span><span >数据安全保护措施</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问、使用、修改，避免数据的损坏或丢失。</span></p>

<p class=MsoNormal><span >我们的服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>SSL</span><span
>、</span><span lang=EN-US style='font-family:"Times New Roman",serif'>TLS</span><span
>）对您的个人信息进行加密保存，并通过隔离技术进行隔离，以保护您的个人信息。在个人信息使用时，例如信息展示、信息关联计算，我们会采用多种数据脱敏技术增强信息在使用中的安全性。我们还会采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制，我们仅允许有必要知晓这些信息的<span
style='color:black'>蛮啾</span>员工、合作伙伴访问您的个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。我们还会举办安全和隐私保护培训课程，加强员工对个人信息保护政策和相关规程的认识。</span></p>

<p class=MsoNormal><span >我们也为安全事件建立了的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全应急预案，进行止损、分析、定位、制定补救措施。在不幸发生信息安全事件后，我们将按照法律法规的要求，以邮件、信函、电话、推送通知等方式及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报信息安全事件的处置情况。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.2
</span><span >数据安全保护的局限性</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >互联网并非绝对安全的环境，我们建议您使用复杂密码，并注意保护您的信息安全。请您务必妥善保管好您的账号、密码及其他身份要素。您在使用<span
style='color:black'>蛮啾</span>产品及服务时，我们会通过您的账号、密码及其他身份要素来识别您的身份。一旦您泄露了前述信息，您可能会蒙受损失，并可能对您产生不利。如您发现账号、密码及</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span><span
>或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</span></p>

<p class=MsoNormal><span >在通过<span style='color:black'>蛮啾</span>产品及服务与第三方进行沟通或购买商品及服务时，您不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮寄地址等。请您妥善保护自己的信息，仅在必要的情形下向他人提供。</span></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span >请您理解，由于技术的限制以及风险防范的局限，即便我们已经尽量加强安全措施，也无法始终保证信息百分之百的安全。您需要了解，您接入<span
style='color:black'>蛮啾</span>产品及服务所用的系统和通讯网络，有可能因我们可控范围外的情况而发生问题。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将在中国法律法规规定的范围内承担相应的法律责任。</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p id="five"  class=MsoNormal><b><span style='font-size:12.0pt;;color:black;
background:#EEEEEE'>五、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;;color:black;background:#EEEEEE'>您如何管理您的个人信息</span></b><b><span
style='font-size:12.0pt;font-family:"Times New Roman",serif'> </span></b><b><span
lang=EN-US style='font-size:11.0pt;font-family:"Times New Roman",serif'>  </span></b><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>                                                              <span
style='color:black;background:#E5E5E5'> </span></span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>1.
</span></b><b><span >您有权查询您的个人信息</span></b></p>

<p class=MsoNormal><span >您可以按照我们提供的产品或服务的相关说明或设置对您已提供给我们的相关信息进行查询，包括：</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>1.1
</span><span >账号信息。您可以通过相关产品及服务页面随时登录您的个人资料页面，以访问您在相应产品内的个人资料信息，如头像、昵称等；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>1.2
</span><span >其他信息。如您在访问过程中遇到操作问题需获取其他前述无法获知的个人信息内容，您可通过我们提供的联系方式联系我们。</span></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>2.
</span></b><b><span >您有权更正您的个人信息</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >当您发现您提供给我们的个人信息存在登记错误、不完整或有更新的，您可以在产品或服务提供的功能界面中在线更正个人信息或通过本隐私政策提供的方式联系我们提出更正申请。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.1
</span><span >对于您的部分个人信息，如头像、昵称等，我们在产品的相关功能页面为您提供了操作设置（以具体产品实际功能为准），您可以直接进行更正</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span><span
>修改。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.2
</span><span >如您在操作过程中有疑惑或困难，可以选择通过我们提供的联系方式联系我们，我们会尽快为您作出解答。经过对您身份的验证，且更正</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>/</span><span
>修改不影响信息的客观性和准确性的情况下，我们可以对错误或不完整的信息作出更正或修改，但法律法规另有规定的除外。但出于安全性和身份识别的考虑，您无法修改注册时提交的实名注册信息。</span></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>3.
</span></b><b><span >您有权删除您的个人信息</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >对于您的部分个人信息，您可以通过本隐私政策提供的方式联系我们提出删除申请。个人信息删除申请审核通过后，我们即会对此类信息进行删除或匿名化处理，除非法律法规另有规定。</span></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>4.
</span></b><b><span >您有权撤回对您个人信息的授权</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >如前所述，您需要授权我们使用您的设备的相关权限（包括摄像头、相册、麦克风或其他权限，具体以产品实际获取的功能为准）以使用我们提供的产品或服务的部分功能，您可以在授权后随时撤回或停止对该权限的授权。例如您可以通过</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>ios</span><span
>设备中的“设置</span><span lang=EN-US style='font-family:"Times New Roman",serif'>-</span><span
>隐私</span><span lang=EN-US style='font-family:"Times New Roman",serif'>-</span><span
>照片”来关闭您对手机相册的授权。如您使用安卓设备，安卓设备撤回授权的途径会根据手机厂商设备不同有所差异，例如您可以通过华为</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>Mate30pro</span><span
>设备中的“设置</span><span lang=EN-US style='font-family:"Times New Roman",serif'>-</span><span
>隐私</span><span lang=EN-US style='font-family:"Times New Roman",serif'>-</span><span
>权限管理”选择相应的应用来关闭您对相机权限的授权。</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >您需要理解，当您撤回授权后，我们无法继续为您提供撤回授权所对应的特定功能或服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>5.
</span></b><b><span >您有权注销您的账号</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >我们向您提供账号注销的途径。在符合我们的服务条款约定条件及国家相关法律法规规定的情况下，您可以通过本隐私政策提供的方式联系我们提出注销申请。除法律法规另有规定或监管部门另有要求外，该账号下的内容、信息、数据、记录将会被删除或匿名化处理。用户账号注销完成后，将无法恢复。</span></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>6.
</span></b><b><span >关于敏感个人信息的特别提示</span></b></p>

<p class=MsoNormal style='text-indent:21.4pt'><b><span >某些个人信息因其特殊性可能被认为是敏感个人信息，您需要谨慎地考虑是否使用我们的服务披露您的敏感个人信息。接受或使用<span
style='color:black'>蛮啾</span>产品及服务视为您同意您的敏感个人信息按本隐私政策所述的目的和方式来处理。</span></b></p>

<p class=MsoNormal><b><span lang=EN-US style='font-family:"Times New Roman",serif'>7.
</span></b><b><span >响应您的上述请求</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。对于您合理的请求，我们不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（如需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者不切实际的请求，我们可能会予以拒绝。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p id="six" class=MsoNormal><b><span style='font-size:12.0pt;;color:black;
background:#EEEEEE'>六、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;;color:black;background:#EEEEEE'>未成年人保护</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >我们高度重视未成年人个人信息的保护问题。我们会积极按照国家防沉迷政策要求，通过启用防沉迷系统保护未成年人的合法权益。我们会通过实名身份信息校验判断相关账号的实名信息是否为未成年人，进而决定是否将此账号纳入到防沉迷体系中。另外，我们会收集您的<u>登录时间、游戏时长、<b>充值记录</b></u>信息，通过从系统层面自动干预和限制未成年人游戏时间、启用强制下线功能、设置消费限额及其他合理方式，引导未成年人合理游戏，帮助未成年人健康上网。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >根据相关法律法规的规定，<b>若您是</b></span><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>18</span></b><b><span
>周岁以下的未成年人，在使用<span style='color:black'>蛮啾</span>产品及服务前，应事先取得您的家长或法定监护人的同意。若您是未成年人的法定监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过本隐私政策提供的联系方式与我们联系。</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >特别地，<b>若您是</b></span><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>14</span></b><b><span
>周岁以下的儿童，我们还专门为您制定了</span></b><b><span lang=EN-US
style='font-family:"Times New Roman",serif'><a
href="/zh/protocol/childProtection" target="_blank"><span lang=EN-US
><span lang=EN-US>《</span></span><span lang=EN-US
style=';color:black'><span lang=EN-US>蛮啾</span></span><span
lang=EN-US ><span lang=EN-US>儿童隐私保护规则<span lang=EN-US>及监护人须知</span></span></span><span
lang=EN-US ><span lang=EN-US>》</span></span></a></span></b><b><span
>，儿童及其监护人在为</span></b><b><span lang=EN-US
style='font-family:"Times New Roman",serif'>14</span></b><b><span
>周岁以下的儿童完成账号注册前，还应仔细阅读</span></b><b><span lang=EN-US
style='font-family:"Times New Roman",serif'><a
href="/zh/protocol/childProtection" target="_blank"><span lang=EN-US
><span lang=EN-US>《</span></span><span lang=EN-US
style=';color:black'><span lang=EN-US>蛮啾</span></span><span
lang=EN-US ><span lang=EN-US>儿童隐私保护规则<span lang=EN-US>及监护人须知</span></span></span><span
lang=EN-US ><span lang=EN-US>》</span></span></a></span></b><b><span
>。只有在取得监护人对</span></b><b><span lang=EN-US
style='font-family:"Times New Roman",serif'><a
href="/zh/protocol/childProtection" target="_blank"><span lang=EN-US
><span lang=EN-US>《</span></span><span lang=EN-US
style=';color:black'><span lang=EN-US>蛮啾</span></span><span
lang=EN-US ><span lang=EN-US>儿童隐私保护规则<span lang=EN-US>及监护人须知</span></span></span><span
lang=EN-US ><span lang=EN-US>》</span></span></a></span></b><b><span
>的同意后，</span></b><b><span lang=EN-US style='font-family:
"Times New Roman",serif'>14</span></b><b><span >周岁以下的儿童方可使用<span
style='color:black'>蛮啾</span>产品及服务。</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><span lang=EN-US style='font-size:12.0pt;font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p id="seven"  class=MsoNormal><b><span style='font-size:12.0pt;;color:black;
background:#EEEEEE'>七、隐私政策的变更</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>1.
</span><span >我们会根据产品的更新情况及法律法规的相关要求更新本隐私政策的条款，该等更新构成本隐私政策的一部分。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。<b>如该等更新造成您在本隐私政策下权利的实质减少或重大变更，我们将通过在显著位置提示或向您发送推送消息或以其他方式通知您，若您继续使用我们的产品或服务，即表示您充分阅读、理解并同意受经修订的本隐私政策的约束。</b></span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.
</span><span >重大变更包括但不限于：</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.1
</span><span >我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.2
</span><span >我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.3
</span><span >个人信息共享、转让或公开披露的主要对象发生变化；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.4
</span><span >您参与个人信息处理方面的权利及其行使方式发生重大变化；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.5
</span><span >我们负责处理个人信息安全相关人员的联络方式及投诉渠道发生变化；</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.6
</span><span >个人信息安全影响评估报告表明存在高风险。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p id="eight"  class=MsoNormal><b><span style='font-size:12.0pt;;color:black;
background:#EEEEEE'>八、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;;color:black;background:#EEEEEE'>其他条款</span></b></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>1.
</span><span >如本隐私政策中的任何条款无论因何种原因完全或部分无效或不具有执行力，本隐私政策的其余条款仍应有效并且有约束力以及具有执行力。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>2.
</span><span >本隐私政策所有条款的标题仅为方便阅读，本身并无实际涵义，不能作为本隐私政策及相关条款涵义解释的依据。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>3.
</span><span style=';color:black'>蛮啾</span><span
>不行使、未能及时行使或者未充分行使本隐私政策或者按照法律法规规定所享有的权利，不应被视为放弃该权利，也不影响<span
style='color:black'>蛮啾</span>在将来行使该权利。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>4.
</span><span style=';color:black'>蛮啾</span><span
>保留对本隐私政策的修改，增补，删除、更新的有关权利。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>5.
</span><span style=';color:black'>本隐私政策的解释及争议解决均应适用中华人民共和国大陆地区法律。任何因本隐私政策以及我们处理您个人信息事宜引起的争议，双方应友好协商解决；协商不成时，任何一方均应向上海市徐汇区人民法院提起诉讼。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

<p id="nine"  class=MsoNormal><b><span style='font-size:12.0pt;;color:black;
background:#EEEEEE'>九、</span></b><b><span style='font-size:12.0pt;font-family:
"Times New Roman",serif;color:black;background:#EEEEEE'> </span></b><b><span
style='font-size:12.0pt;;color:black;background:#EEEEEE'>联系我们</span></b></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >当您有关于网络信息安全的投诉和举报，或您对本隐私政策、您的个人信息的相关事宜有任何问题、意见或建议时，可发送邮件至</span><b><span
lang=EN-US style='font-family:"Times New Roman",serif'>cs@manjuu.com</span></b><span
>或写信寄送到如下地址：</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >上海市徐汇区宜山路</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>700</span><span
>号</span><span lang=EN-US style='font-family:"Times New Roman",serif'>B2</span><span
>栋</span><span lang=EN-US style='font-family:"Times New Roman",serif'>1503</span><span
>室上海<span style='color:black'>蛮啾</span>科技有限公司</span><span
style='font-family:"Times New Roman",serif'> </span><span>个人信息保护专员（收）；邮编：</span><span lang=EN-US style='font-family:"Times New Roman",serif'>200233</span><span
>。</span></p>

<p class=MsoNormal style='text-indent:21.0pt'><span >我们将尽快审核所涉问题，并在验证您的用户身份后的</span><span
lang=EN-US style='font-family:"Times New Roman",serif'>15</span><span
>个工作日或法律法规规定的期限内予以反馈。</span></p>

<p class=MsoNormal><span lang=EN-US style='font-family:"Times New Roman",serif'>&nbsp;</span></p>



<p class=MsoNormal align=left style='text-align:left'><span lang=EN-US
style='font-family:"Times New Roman",serif'>&nbsp;</span></p>

</div>

</body>

</html>

`;

export default privacyContent;
